export const SENTRY_CONFIGURATION_PROPERTY =
  'soldevelo-qality-sentry-recording-agreement';

export type SentryAgreementProperty = {
  allowSentryRecording: boolean;
};
